import { ModalFooter } from '@atlaskit/modal-dialog';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Spinner from '@atlaskit/spinner';

interface Props {
  isReasonSelected: boolean;
  isSubmitting: boolean;
  onSendRecognition: () => void;
}

export const KudosModalFooter = ({
  isReasonSelected,
  isSubmitting,
  onSendRecognition,
}: Props) => {
  const isButtonDisabled = !isReasonSelected || isSubmitting;

  return (
    <ModalFooter>
      <div css={giveRecognitionFooterStyles}>
        <p css={recognitionAmountStyles}>{'+100 PTS'}</p>
        <div>
          <button
            onClick={onSendRecognition}
            type="submit"
            css={[
              giveRecognitionButton,
              isReasonSelected && !isSubmitting && giveRecognitionButtonActive,
            ]}
            disabled={isButtonDisabled}
          >
            <div css={buttonContentStyles}>
              {isSubmitting && (
                <div css={centeredSpinnerStyles}>
                  <Spinner size="small" />
                </div>
              )}
              <span css={[isSubmitting && hiddenTextStyles]}>
                {'Give recognition'}
              </span>
            </div>
          </button>
        </div>
      </div>
    </ModalFooter>
  );
};

const giveRecognitionButton = css({
  position: 'absolute',
  right: '16px',
  bottom: '16px',
  display: 'flex',
  height: '40px',
  padding: `${token('space.100')} ${token('space.150')}`,
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  color: token('color.text.disabled'),
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '20px',
  backgroundColor: token('color.background.disabled'),
  borderRadius: '4px',
  borderStyle: 'none',
  cursor: 'pointer',
});

const giveRecognitionButtonActive = css({
  backgroundColor: token('color.background.accent.blue.bolder'),
  color: token('color.text.inverse'),
  cursor: 'pointer',
});

const recognitionAmountStyles = css({
  display: 'flex',
  height: '40px',
  padding: `${token('space.100')} ${token('space.150')}`,
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  position: 'absolute',
  left: '16px',
  bottom: '16px',
  color: 'var(--Extended-Lime-L600, #6A9A23)',
  textAlign: 'center',
  fontFamily: token('font.family.brand.body'),
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '20px' /* 125% */,
});

const giveRecognitionFooterStyles = css({
  display: 'flex',
  padding: '24px 0px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
});

const buttonContentStyles = css({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: token('space.075'), // 6px gap between spinner and text
});

const hiddenTextStyles = css({
  visibility: 'hidden',
});

const centeredSpinnerStyles = css({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
});
